import { i as t } from "./index.es279.js";
var n = t;
function o(i) {
  return n(i) ? void 0 : i;
}
var r = o;
export {
  r as _
};
//# sourceMappingURL=index.es99.js.map
